// extracted by mini-css-extract-plugin
module.exports = {"panel":"Login_panel__eAwHc"};